import * as THREE from 'three';
import Action from '../classes/Action';
import ARTracker from '../classes/ARTracker';
import Engine from '../classes/Engine';
import Scenario from '../classes/scenarioElements/Scenario';
import { CustomEventTypes } from '../globals';
import { IObjectSelection } from '../interfaces/Misc';

export default class PasteObjectsAction extends Action
{
	constructor(objects: THREE.Object3D[], parents: THREE.Object3D | THREE.Object3D[] | undefined, actionName: string)
	{
		const previousSelection = Engine.getInstance().getPickingManager().getCurrentSelection();
		const root = Engine.getInstance().getSelectionRoot();

		if(!parents)
		{
			parents = new Array(objects.length).fill(root);
		}
		else if (!Array.isArray(parents))
		{
			parents = new Array(objects.length).fill(parents);
		}

		// ensure valid parents
		for(let i = 0; i < parents.length; i++)
		{
			if(!parents[i])
			{
				parents[i] = root;
			}
		}

		super([objects, parents], [objects, previousSelection], actionName, [objects, parents]);
	}

	do(objects: THREE.Object3D[], parents: THREE.Object3D[]) : void
	{
		Engine.getInstance().getPickingManager().clearSelection(false);
		const cps = Scenario.getCPS()!;
		for(let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			const parent = parents[i];

			if (!(object instanceof ARTracker) && parent === ARTracker.getTrackerRoot())
			{
				Engine.getInstance().addObject(object, Engine.getInstance().getSelectionRoot());
			}
			else if (object instanceof ARTracker && parent !== ARTracker.getTrackerRoot())
			{
				Engine.getInstance().addObject(object, ARTracker.getTrackerRoot());
			}
			else
			{
				Engine.getInstance().addObject(object, parent);
			}
			Engine.getInstance().getPickingManager().selectObject(object);

			if (object instanceof ARTracker)
			{
				cps.trackers!.push(object.userData.guid);
				document.dispatchEvent(new CustomEvent(CustomEventTypes.onTrackerListUpdated));
			}
		}

		Engine.getInstance().getPickingManager().storeSelection();
		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updatePropertiesComponent));
	}

	undo(objects: THREE.Object3D[], previousSelection: IObjectSelection) : void
	{
		Engine.getInstance().getPickingManager().restoreSelection(previousSelection);

		const cps = Scenario.getCPS()!;
		for (const object of objects)
		{
			if (object instanceof ARTracker)
			{
				cps.trackers = cps.trackers!.filter((t) => t !== object.userData.guid);
				document.dispatchEvent(new CustomEvent(CustomEventTypes.onTrackerListUpdated));
			}
			Engine.getInstance().removeObject(object, true);
		}
	}

	verify(objects: THREE.Object3D[], parents: THREE.Object3D[])
	{
		if(!Array.isArray(objects) || !Array.isArray(parents)) return false;

		return objects.length === parents.length;
	}
}
